window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener(
    "shopify:section:load",
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    "shopify:section:unload",
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    "shopify:section:select",
    this._onSelect.bind(this)
  );
  document.addEventListener(
    "shopify:section:deselect",
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    "shopify:block:select",
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    "shopify:block:deselect",
    this._onBlockDeselect.bind(this)
  );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var id = container.getAttribute("data-section-id");
    var type = container.getAttribute("data-section-type");

    constructor = constructor || this.constructors[type];

    if (typeof constructor === "undefined") {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"]'
    );

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = this.instances.filter(function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === "function") {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onSelect === "function"
    ) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onDeselect === "function"
    ) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockSelect === "function"
    ) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockDeselect === "function"
    ) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function (container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

theme.collectionSlider = (function () {
  function sliderProduct(e) {
    let sliderContainer = "",
      extraLargeDesktopShow = 4,
      largeDesktopShow = 3,
      tabletShow = 3,
      mobileShow = 2,
      sliderAutoplay = e.dataset.autoplay,
      loopSelector = e.dataset.sliderLoop,
      loopInit = false,
      autoPlayValue = false,
      autoPlayTime = parseInt(e.dataset.autoplayTime);

    if (sliderAutoplay == "true") {
      autoPlayValue = {
        delay: autoPlayTime,
      };
    }

    if (loopSelector == "true") {
      loopInit = true;
    }

    if (e.dataset.sliderEnable === "true") {
      sliderContainer = e.querySelector(".productSlider");
      extraLargeDesktopShow = parseInt(e.dataset.showExtraLarge);
      mobileShow = parseInt(e.dataset.showMobile);
      if (typeof e.dataset.showTablet !== "undefined") {
        tabletShow = e.dataset.showTablet;
      } else {
        tabletShow = extraLargeDesktopShow;
      }
    } else {
      sliderContainer = false;
    }

    var featuredCollection = new Swiper(sliderContainer, {
      loop: true,
      slidesPerView: mobileShow,
      spaceBetween: 20,
      autoplay: autoPlayValue,
      pagination: {
        el: e.querySelector(".swiper-pagination"),
        clickable: true,
        type: "fraction",
      },
      navigation: {
        nextEl: e.querySelector(".swiper-button-next"),
        prevEl: e.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        640: {
          slidesPerView: mobileShow,
        },
        750: {
          slidesPerView: tabletShow,
        },
        992: {
          slidesPerView: extraLargeDesktopShow,
        },
      },
    });

    if (!sliderContainer == false && sliderAutoplay == "true") {
      sliderContainer.addEventListener("mouseenter", (e) => {
        featuredCollection.autoplay.stop();
      });
      sliderContainer.addEventListener("mouseleave", (e) => {
        featuredCollection.autoplay.start();
      });
    }
    // Slide thumbnail height
    const slideThumbHeight = () => {
      const proudctThumbnails = e.querySelectorAll(".card--client-height");
      if (proudctThumbnails.length > 0) {
        const productThumbnailHeight = proudctThumbnails[0];
        e.style.setProperty(
          "--slider-navigation-top-offset",
          `${productThumbnailHeight.clientHeight / 2}px`
        );
      }
    };
    slideThumbHeight();
    window.addEventListener("resize", () => {
      slideThumbHeight();
    });
  }
  return sliderProduct;
})();

document.addEventListener("DOMContentLoaded", function () {
  let sections = new theme.Sections(),
    headerSearchModule = new theme.Sections(),
    headerCartModule = new theme.Sections(),
    headerStickyModule = new theme.Sections(),
    headerMainMenu = new theme.Sections();

  sections.register("announcement-bar", theme.announcement);
  sections.register("header", theme.headerSection);
  headerSearchModule.register("header", theme.headerSearch);
  headerCartModule.register("header", theme.CartDrawerActions);
  headerStickyModule.register("header", theme.headerSticky);
  headerMainMenu.register("header", theme.headerMainMenuModule);
  sections.register("footer", theme.footerSection);
  sections.register("slideShow", theme.SlideShow);
  sections.register("collection-product", theme.collectionProduct);
  sections.register("product-slider", theme.collectionSlider);
  sections.register("accordion", theme.accordion);
  sections.register("blog", theme.blog);
  sections.register("lookbook", theme.lookbookSlider);
  sections.register("timeline", theme.timelineSlider);
});

/* ==========================================================
 * FixDesk patch appended below — the product-page picker.
 * Unfolds the three Shopify options into four rows:
 * Storage, Colour as real swatches, Condition, and
 * What's Included, each chip carrying its own price.
 *
 * Source of truth: themes/smpr-mavon-patches/ in the FixDesk
 * repo. Everything ABOVE this banner is Mavon stock code,
 * verified byte-identical (md5 1bf971a7) before appending.
 * To remove the patch, delete from this banner to EOF.
 * ========================================================== */
/*
 * fd-hide-unavailable-options.js — SMPR / Mavon product-page picker
 *
 * Shopify caps a product at THREE options, so FixDesk folds four axes
 * into three: connectivity rides inside Storage ("128GB + Cellular")
 * and what's-included rides inside Condition ("As New · Box + Cable").
 * This unfolds them again on the storefront, so the customer sees the
 * four rows George asked for:
 *
 *     STORAGE     [ 64GB ] [ 128GB ]
 *     COLOUR      ( ) ( ) ( )              ← the actual colour
 *     CONDITION   [ As New ] [ Excellent ] [ Good ]
 *     INCLUDED    [ Complete ] [ Box + Cable ]
 *
 * His words, 19 Sep 2026, after showing the Reebelo page: "can we do
 * Storage, Colours like in a shape with the actual colour of the item,
 * Condition, and then Option to select what they [want] or what is
 * available".
 *
 * NONE OF THIS LOGIC IS NEW. `themes/geogadgets-clean/assets/theme.js`
 * has done exactly this since PR #326 — decompose(), the cascade, the
 * swatch map, the row renderer. It has simply never reached SMPR, which
 * still runs the paid Mavon theme. This is that picker ported onto
 * Mavon's markup, and it should be deleted the day the new layout ships.
 * Fix a rule in both files or in neither.
 *
 * ── How it attaches to Mavon ────────────────────────────────────────
 *
 * Mavon renders one `fieldset.product-form__input` per REAL Shopify
 * option, with radios inside. Those radios are what the form posts and
 * what the theme watches to recompute price, image and the buy button,
 * so they stay — hidden, and driven from our rows. We never post, price
 * or add to cart ourselves; Mavon keeps doing all of that.
 *
 * ── The rules, all George's, all from the same screen ───────────────
 *
 * 1. "i only want it to only show what's available not crossed out …
 *    once you select colour it will only show what we have in stock" —
 *    a value that cannot be bought is not rendered at all.
 *
 * 2. Availability CASCADES: an axis is constrained by the axes ABOVE it
 *    and never by the ones below. This is not a detail. Mavon's own
 *    marking is symmetric, and the first version of this patch hid on
 *    that basis — so landing on "Good · Device Only" left Storage
 *    showing only 64GB and Colour only Grey, with 128GB, Silver and
 *    Blue unreachable by any click on the page. Downward-only keeps
 *    every variant reachable, which is the entire point of hiding.
 *
 * 3. A selection the cascade kills is MOVED, never left dangling
 *    (cascadeFix). Otherwise the form posts a variant nobody can buy.
 *
 * 4. "we only default the cheapest product pre selected" — the page
 *    opens on the cheapest AVAILABLE variant, not Shopify's first.
 *    An explicit `?variant=` always wins: Google Shopping and every
 *    shared link carry one, and overriding it lands the customer on a
 *    different phone from the one the ad showed.
 *
 * 5. The price sits on each chip (Reebelo does this, and it is the
 *    number being chosen between). It is the cheapest variant reachable
 *    from that value given the axes above it — what they would pay if
 *    they clicked it, not a from-price for the model.
 *
 * 6. "for the key i only want to fade in when they select that option
 *    like after colour" — a row whose values changed fades. A row that
 *    did not change is left alone; animating everything is a flicker.
 *
 * 7. Under Condition and under What's Included, a line saying what the
 *    choice MEANS. The wording is copied from
 *    src/lib/universalDescription.js — the same words the listing
 *    description uses — and test/pdpKey.test.js fails if they drift.
 *    A store must not promise a charger on one screen and not the other.
 *
 * KNOWN, AND NOT THIS FILE'S TO FIX: some bundle labels do not describe
 * what is actually in the box. `box + cable + hands-free` is stored as
 * `complete`, so the line under What's Included promises a charger that
 * is not there. The derivation is the bug (titleParser.mapItemsToBundle
 * and its mirror in public/components/tile-picker.js); this file only
 * reports what it is given. See docs/CHECKLIST.md.
 */
(function () {
  'use strict';

  var ROW = 'fieldset.product-form__input';    // Mavon: one per real option
  var COND_SEP = ' · ';                        // MUST match fieldMap.combinedConditionValue
  var CELL_SUFFIX = ' + Cellular';             // MUST match fieldMap.storageLabel
  var WRAP_ID = 'fd-virtual-picker';

  var installed = false;
  var product = null;                          // /products/<handle>.js
  var axes = [];                               // virtual axis names, in order
  var decomposed = [];                         // [{ v, d }]
  var optionNames = [];                        // Mavon's real option names
  var storageIdx = -1, condIdx = -1;
  var sel = {};                                // current virtual selection
  var signatures = {};                         // axis -> values last painted
  var touched = false;

  // Copied from src/lib/universalDescription.js (CONDITION_ROWS,
  // BUNDLE_LEGEND). Keys lowercased so a label's casing cannot miss.
  var CONDITION_LEGEND = {
    'as new':    'No visible marks. Looks unused.',
    'excellent': 'Light signs of use you have to look for. No marks on the screen when it\'s on.',
    'good':      'Visible wear on the body or edges. Screen works perfectly.',
  };
  var BUNDLE_LEGEND = {
    'complete':        'Original box, charger and charging cable',
    'box + cable':     'Original box and charging cable — no charger',
    'box only':        'Original box — no cable or charger',
    'charger + cable': 'Charger and charging cable — no box',
    'cable only':      'Charging cable — no box or charger',
    'device only':     'The device on its own — no box, cable or charger',
  };

  // Colour swatch mapping lives in JS, not Liquid — the Geo Gadgets
  // Liquid map silently failed and rendered every dot #999999 grey
  // (PR #327/#328). Same table as themes/geogadgets-clean.
  var SWATCH_HEX = {
    'black': '#1c1c1c', 'phantom black': '#1a1a1c', 'graphite black': '#2a2a2a',
    'white': '#f2f2f0', 'phantom white': '#ece9e2',
    'graphite': '#3a3a3a', 'space gray': '#54585c', 'space grey': '#54585c',
    'grey': '#7a7d80', 'gray': '#7a7d80',
    'silver': '#cfd2d6', 'mystic silver': '#cfd2d6',
    'gold': '#e3c9a0', 'rose gold': '#e8c2b3',
    'bronze': '#b08d6e', 'mystic bronze': '#b08d6e',
    'starlight': '#f0ead6', 'midnight': '#1f2233',
    'blue': '#235aa3', 'mystic blue': '#235aa3', 'navy': '#1d2b4a',
    'red': '#c8302a', 'green': '#4a8b5a', 'yellow': '#f3c92a',
    'purple': '#7e5fbf', 'pink': '#e89ab0', 'orange': '#e58438',
    'titanium': '#7a8085', 'natural titanium': '#8a8480', 'white titanium': '#d6cfc6',
    'blue titanium': '#5d6f7d', 'black titanium': '#2f3133', 'desert titanium': '#aa9173',
    'brown': '#8a6948', 'beige': '#d8c8a8', 'cream': '#f0e6d3', 'charcoal': '#36383b',
    'sage': '#94a78d', 'mint': '#9ed8c4', 'coral': '#f08f7a', 'lavender': '#c3b0e0',
  };
  var SWATCH_FALLBACKS = [
    ['titanium', '#7a8085'], ['black', '#1c1c1c'], ['white', '#f2f2f0'],
    ['blue', '#235aa3'], ['green', '#4a8b5a'], ['red', '#c8302a'], ['rose', '#e8c2b3'],
    ['gold', '#e3c9a0'], ['silver', '#cfd2d6'], ['pink', '#e89ab0'], ['purple', '#7e5fbf'],
    ['bronze', '#b08d6e'], ['grey', '#7a7d80'], ['gray', '#7a7d80'],
  ];
  function swatchHex(value) {
    var v = String(value || '').toLowerCase().trim();
    if (SWATCH_HEX[v]) return SWATCH_HEX[v];
    for (var i = 0; i < SWATCH_FALLBACKS.length; i++) {
      if (v.indexOf(SWATCH_FALLBACKS[i][0]) !== -1) return SWATCH_FALLBACKS[i][1];
    }
    return '#999999';
  }

  function style() {
    if (document.getElementById('fd-picker-style')) return;
    var el = document.createElement('style');
    el.id = 'fd-picker-style';
    el.textContent = [
      // Mavon's own rows still drive the form; they are just not shown.
      // Kept in the DOM and focusable-free rather than removed, so the
      // theme's handlers and the posted form are untouched.
      '#' + WRAP_ID + '.ready ~ ' + ROW + ',',
      '#' + WRAP_ID + '.ready + ' + ROW + '{display:none !important}',
      '.fd-row{margin:0 0 20px}',
      '.fd-row-name{font-size:12px;font-weight:700;letter-spacing:.06em;',
      'text-transform:uppercase;color:var(--text-muted,#6b6a64);margin-bottom:9px}',
      '.fd-row-sel{margin-left:8px;text-transform:none;letter-spacing:0;font-weight:500}',
      '.fd-chips{display:flex;flex-wrap:wrap;gap:8px}',
      '.fd-chip{padding:10px 16px;border:1px solid var(--border,#e5e3dc);border-radius:8px;',
      'font-size:13px;font-weight:600;cursor:pointer;background:#fff;color:var(--text,#1a1a16);',
      'text-align:center;line-height:1.3;font-family:inherit}',
      '.fd-chip:hover{border-color:var(--text,#1a1a16)}',
      '.fd-chip.on{border-color:var(--text,#1a1a16);box-shadow:inset 0 0 0 1px var(--text,#1a1a16)}',
      '.fd-chip-price{display:block;font-size:12px;font-weight:600;opacity:.7;margin-top:2px}',
      // The colour swatch: the shape carries the actual colour, so the
      // ring rather than a fill has to show selection.
      '.fd-sw{width:38px;height:38px;padding:0;border-radius:50%;cursor:pointer;',
      'border:2px solid #fff;box-shadow:0 0 0 1px var(--border,#e5e3dc);background:transparent;',
      'display:inline-flex;align-items:center;justify-content:center}',
      '.fd-sw:hover{box-shadow:0 0 0 2px var(--text,#1a1a16)}',
      '.fd-sw.on{box-shadow:0 0 0 2px var(--text,#1a1a16)}',
      '.fd-sw i{width:100%;height:100%;border-radius:50%;display:block}',
      '.fd-note{margin-top:10px;padding:10px 13px;border-radius:8px;',
      'background:var(--bg-alt,#f6f5f1);color:var(--text-muted,#6b6a64);',
      'font-size:13px;line-height:1.5}',
      '@keyframes fd-fade-in{from{opacity:0;transform:translateY(4px)}to{opacity:1;transform:none}}',
      '.fd-faded{animation:fd-fade-in .28s ease-out}',
      // Asked for less motion: the row still changes, it just does not travel.
      '@media (prefers-reduced-motion:reduce){.fd-faded{animation:none}}',
    ].join('');
    (document.head || document.documentElement).appendChild(el);
  }

  // ── Reading Mavon ──────────────────────────────────────────────────
  function rows() { return document.querySelectorAll(ROW); }

  // Mavon's legend markup is:
  //
  //     <legend>\n        <strong>Condition:</strong> <span>As New · Box
  //     + Cable</span>\n      </legend>
  //
  // so the axis name sits in the <strong>, and legend.textContent is
  // "\n        Condition: As New · Box + Cable\n      " — name, colon,
  // current value, wrapped in indentation.
  //
  // Two things bit here, both silent, both only visible against the real
  // store. Get the name wrong and it falls back to "Option 3";
  // indexOf('condition') then misses, condIdx stays -1, and the folded
  // value is NEVER split — one chip reading "As New · Box + Cable", no
  // What's Included row, no swatches, and nothing in the console.
  //
  //   1. The colon. "Condition:" is not "condition".
  //   2. The LEADING NEWLINE. Splitting on \n before trimming yields the
  //      empty string, because the text starts with one. This is what
  //      actually shipped to the theme and rendered "Option 1/2/3" — my
  //      own test called .trim() first and so never saw it.
  //
  // Prefer the <strong>, which is just the name, and keep the text
  // parsing as the fallback for a Mavon version that drops it.
  function rowOptionName(row, i) {
    var legend = row.querySelector('legend');
    if (!legend) return 'Option ' + (i + 1);
    var strong = legend.querySelector ? legend.querySelector('strong') : null;
    var t = (strong && strong.textContent) || legend.textContent || '';
    t = String(t)
      .trim()                           // the indentation, FIRST
      .split('\n')[0]                   // value on a second line
      .replace(/\s{2,}[\s\S]*$/, '')    // …or after a run of whitespace
      .trim()
      .replace(/:.*$/, '')              // …or after the colon
      .trim();
    return t || ('Option ' + (i + 1));
  }

  function radiosIn(row) { return row.querySelectorAll('input[type="radio"]'); }

  // ── The virtual axes ───────────────────────────────────────────────
  function decompose(v) {
    var d = {};
    [v.option1, v.option2, v.option3].forEach(function (o, i) {
      if (o == null || i >= optionNames.length) return;
      if (i === storageIdx) {
        if (o.slice(-CELL_SUFFIX.length) === CELL_SUFFIX) {
          d['Storage'] = o.slice(0, -CELL_SUFFIX.length);
          d['Connectivity'] = 'Cellular';
        } else {
          d['Storage'] = o;
          d['Connectivity'] = 'Wi-Fi';
        }
      } else if (i === condIdx) {
        var at = o.indexOf(COND_SEP);
        if (at !== -1) {
          d['Condition'] = o.slice(0, at);
          d["What's Included"] = o.slice(at + COND_SEP.length);
        } else {
          d['Condition'] = o;
        }
      } else {
        d[optionNames[i]] = o;
      }
    });
    return d;
  }

  // Order: Storage, Connectivity, the remaining real axes (Colour, …),
  // then Condition, then What's Included. The derived names are placed
  // explicitly rather than taken from the real-name loop — on the Geo
  // Gadgets catalogue What's Included IS a real option, and taking it
  // from both rendered the row twice.
  var DERIVED = ['Storage', 'Connectivity', 'Condition', "What's Included"];
  function buildAxes() {
    axes = [];
    function push(n) { if (axes.indexOf(n) === -1) axes.push(n); }
    if (storageIdx !== -1) {
      push('Storage');
      if (product.variants.some(function (v) { return decompose(v)['Connectivity'] === 'Cellular'; })) {
        push('Connectivity');
      }
    }
    optionNames.forEach(function (n, i) {
      if (i === storageIdx || i === condIdx) return;
      if (DERIVED.indexOf(n) !== -1) return;
      push(n);
    });
    if (condIdx !== -1) push('Condition');
    if (product.variants.some(function (v) { return decompose(v)["What's Included"] != null; })) {
      push("What's Included");
    }
  }

  function axisValues(axis) {
    var seen = [];
    decomposed.forEach(function (e) {
      var val = e.d[axis];
      if (val != null && seen.indexOf(val) === -1) seen.push(val);
    });
    return seen;
  }

  // Rule 2: only the axes ABOVE this one constrain it.
  function valueAvailable(axis, val) {
    return decomposed.some(function (e) {
      if (e.v.available !== true) return false;
      if (e.d[axis] !== val) return false;
      for (var k = 0; k < axes.length; k++) {
        var b = axes[k];
        if (b === axis) break;
        if (e.d[b] !== undefined && e.d[b] !== sel[b]) return false;
      }
      return true;
    });
  }

  // Rule 5: cheapest reachable from this value, axes above held.
  function priceFor(axis, val) {
    var best = null;
    for (var i = 0; i < decomposed.length; i++) {
      var e = decomposed[i];
      if (e.v.available !== true) continue;
      if (e.d[axis] !== val) continue;
      var ok = true;
      for (var k = 0; k < axes.length; k++) {
        var b = axes[k];
        if (b === axis) break;
        if (e.d[b] !== undefined && e.d[b] !== sel[b]) { ok = false; break; }
      }
      if (ok && (best === null || Number(e.v.price) < best)) best = Number(e.v.price);
    }
    return best;
  }

  function money(cents) {
    var n = Number(cents) / 100;
    try {
      return new Intl.NumberFormat('en-AU', {
        style: 'currency', currency: 'AUD',
        minimumFractionDigits: n % 1 === 0 ? 0 : 2, maximumFractionDigits: 2,
      }).format(n);
    } catch (e) {
      return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
    }
  }

  function matchVariant(mustBeAvailable) {
    for (var i = 0; i < decomposed.length; i++) {
      var e = decomposed[i];
      if (mustBeAvailable && e.v.available !== true) continue;
      var all = true;
      for (var k = 0; k < axes.length; k++) {
        var a = axes[k];
        if (e.d[a] !== undefined && e.d[a] !== sel[a]) { all = false; break; }
      }
      if (all) return e.v;
    }
    return null;
  }

  // Rule 3.
  function cascadeFix() {
    axes.forEach(function (axis) {
      if (sel[axis] !== undefined && valueAvailable(axis, sel[axis])) return;
      var firstOk = axisValues(axis).filter(function (val) { return valueAvailable(axis, val); })[0];
      if (firstOk !== undefined) sel[axis] = firstOk;
    });
  }

  // ── Driving Mavon ──────────────────────────────────────────────────
  // Set every real radio to the chosen variant's option values, then let
  // the theme recompute from ONE change event. Clicking each in turn
  // would make Mavon re-render the section once per axis.
  var writing = false;
  function syncToTheme() {
    var v = matchVariant(true) || matchVariant(false);
    if (!v) return;
    var want = [v.option1, v.option2, v.option3];
    var all = rows();
    var last = null;
    writing = true;
    try {
      for (var r = 0; r < all.length && r < want.length; r++) {
        var inputs = radiosIn(all[r]);
        for (var j = 0; j < inputs.length; j++) {
          var hit = inputs[j].value === want[r];
          if (hit && !inputs[j].checked) { inputs[j].checked = true; last = inputs[j]; }
          else if (hit) { last = last || inputs[j]; }
          else { inputs[j].checked = false; }
        }
      }
      if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
    } finally {
      writing = false;
    }
  }

  // ── Rendering our rows ─────────────────────────────────────────────
  function wrapper() {
    var w = document.getElementById(WRAP_ID);
    if (w) return w;
    var first = rows()[0];
    if (!first) return null;
    w = document.createElement('div');
    w.id = WRAP_ID;
    first.parentNode.insertBefore(w, first);
    return w;
  }

  function noteFor(axis, value) {
    var k = String(value || '').toLowerCase();
    if (axis === 'Condition') {
      return CONDITION_LEGEND[k] ? value + ' — ' + CONDITION_LEGEND[k] : '';
    }
    if (axis === "What's Included") return BUNDLE_LEGEND[k] || '';
    return '';
  }

  function render() {
    var w = wrapper();
    if (!w) return;
    w.textContent = '';

    axes.forEach(function (axis) {
      var values = axisValues(axis).filter(function (val) { return valueAvailable(axis, val); });
      if (!values.length) return;
      // No Connectivity row unless Cellular is actually on offer here —
      // an all-Wi-Fi model should say nothing rather than say "Wi-Fi".
      if (axis === 'Connectivity' && values.length === 1 && values[0] === 'Wi-Fi') return;

      var isColour = ['colour', 'color'].indexOf(axis.toLowerCase()) !== -1;

      var row = document.createElement('div');
      row.className = 'fd-row';

      var name = document.createElement('div');
      name.className = 'fd-row-name';
      name.textContent = axis;
      var selLabel = document.createElement('span');
      selLabel.className = 'fd-row-sel';
      selLabel.textContent = sel[axis] || '';
      name.appendChild(selLabel);
      row.appendChild(name);

      var list = document.createElement('div');
      list.className = 'fd-chips';
      list.setAttribute('role', 'radiogroup');
      list.setAttribute('aria-label', axis);

      values.forEach(function (val) {
        var on = sel[axis] === val;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
        btn.setAttribute('aria-label', val);

        if (isColour) {
          btn.className = 'fd-sw' + (on ? ' on' : '');
          btn.title = val;
          var dot = document.createElement('i');
          dot.style.background = swatchHex(val);
          btn.appendChild(dot);
        } else {
          btn.className = 'fd-chip' + (on ? ' on' : '');
          btn.appendChild(document.createTextNode(val));
          var cents = priceFor(axis, val);
          if (cents !== null) {
            var p = document.createElement('span');
            p.className = 'fd-chip-price';
            p.textContent = money(cents);
            btn.appendChild(p);
          }
        }

        btn.addEventListener('click', function () {
          touched = true;
          sel[axis] = val;
          cascadeFix();
          syncToTheme();
          render();
        });
        list.appendChild(btn);
      });

      row.appendChild(list);

      // Rule 7 — what the choice MEANS, under the row it belongs to.
      var note = noteFor(axis, sel[axis]);
      if (note) {
        var n = document.createElement('p');
        n.className = 'fd-note';
        n.textContent = note;
        row.appendChild(n);
      }

      // Rule 6 — fade only what changed.
      var sig = values.join('␟') + '|' + (sel[axis] || '') + '|' + note;
      if (signatures[axis] !== undefined && signatures[axis] !== sig) row.className += ' fd-faded';
      signatures[axis] = sig;

      w.appendChild(row);
    });

    w.className = 'ready';
  }

  // Rule 4.
  function applyCheapest() {
    var best = null;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (!v.available) continue;
      if (!best || Number(v.price) < Number(best.price)) best = v;
    }
    if (best) sel = decompose(best);
  }

  function start(p) {
    product = p;
    var all = rows();
    if (!all.length || !product.variants || !product.variants.length) return;

    optionNames = [];
    for (var r = 0; r < all.length; r++) optionNames.push(rowOptionName(all[r], r));
    var lower = optionNames.map(function (n) { return n.toLowerCase().trim(); });
    storageIdx = lower.indexOf('storage');
    condIdx = lower.indexOf('condition');

    buildAxes();
    decomposed = product.variants.map(function (v) { return { v: v, d: decompose(v) }; });

    // An explicit ?variant= is the customer's, not ours.
    var wanted = new URLSearchParams(location.search).get('variant');
    var pinned = wanted && product.variants.filter(function (v) { return String(v.id) === String(wanted); })[0];
    if (pinned) sel = decompose(pinned); else applyCheapest();

    cascadeFix();
    syncToTheme();
    render();

    // Mavon re-renders the picker from a section fetch on some changes,
    // which replaces the radios under us. Re-attach when that happens —
    // but never in response to our OWN writes, which is an infinite loop.
    if (window.MutationObserver) {
      var scope = document.getElementById('MainContent') || document.body;
      if (scope) {
        var pending = null;
        new MutationObserver(function () {
          if (writing) return;
          if (document.getElementById(WRAP_ID)) return;   // ours survived
          window.clearTimeout(pending);
          pending = window.setTimeout(function () { render(); }, 60);
        }).observe(scope, { subtree: true, childList: true });
      }
    }
  }

  function install() {
    if (installed) return;
    installed = true;
    style();
    var path = location.pathname.split('?')[0].replace(/\/+$/, '');
    if (path.indexOf('/products/') === -1) return;
    fetch(path + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p && p.variants) start(p); })
      .catch(function () { /* Mavon's own picker is left exactly as it was */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', install);
  } else {
    install();
  }
})();
